import type { Film } from "@/types";

export const films: Film[] = [
  {
    id: "naughty-girlfriend",
    title: "顽皮的女朋友",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20comedy%20TV%20drama%20poster%20featuring%20a%20cheerful%20young%20couple%20laughing%20together%20on%20a%20city%20rooftop%20at%20sunset%2C%20warm%20amber%20and%20deep%20crimson%20color%20palette%2C%20soft%20cinematic%20lighting%2C%20playful%20mood%2C%20minimalist%20elegant%20poster%20composition%20with%20negative%20space%20at%20the%20top%2C%20high%20detail%20editorial%20key%20art&width=400&height=600&seq=film-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20from%20a%20romantic%20comedy%20drama%20showing%20a%20joyful%20young%20couple%20running%20hand%20in%20hand%20through%20a%20sunlit%20city%20street%20with%20warm%20golden%20hour%20glow%2C%20deep%20crimson%20and%20amber%20tones%2C%20soft%20bokeh%20background%2C%20film%20grain%20texture%2C%20emotional%20and%20playful%20atmosphere%2C%20high%20detail%20cinematic%20composition&width=1600&height=900&seq=film-backdrop-01&orientation=landscape",
    type: "电视剧",
    region: "国产",
    year: 2024,
    genres: ["爱情", "喜剧", "都市"],
    cast: ["林小满", "陆时晏", "苏晴", "周牧"],
    director: "陈嘉行",
    synopsis:
      "一个爱捣乱却心地善良的女孩，遇上高冷又嘴硬的天才程序员，两人从互相看不顺眼到彼此治愈，展开一段笑料不断又甜到心里的都市爱情故事。",
    plot: [
      "《顽皮的女朋友》讲述了活泼跳脱的插画师林小满与理性克制的程序员陆时晏之间，从一场乌龙合租开始的浪漫故事。初识时，两人因为生活习惯与性格的巨大差异冲突不断，林小满的古灵精怪总能精准打破陆时晏一成不变的秩序。",
      "随着相处加深，陆时晏逐渐发现林小满调皮外表下藏着的细腻与坚持，而林小满也在一次次并肩面对生活难题的过程中，看见了他沉默背后的温柔。两人从针锋相对到慢慢靠近，笑与泪交织地走进了彼此的世界。",
      "剧集以轻快幽默的笔触探讨了当代年轻人关于梦想、成长与亲密关系的困惑，用一段段真实可爱的生活细节，讲述了一段关于理解与陪伴的温暖故事。",
    ],
    heat: 9860,
    releaseDate: "2024-08-16",
    featured: true,
  },
  {
    id: "heartbeat-signal",
    title: "心动信号",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20poster%20showing%20a%20young%20woman%20holding%20a%20glowing%20phone%20with%20a%20soft%20smile%2C%20cozy%20warm%20red%20and%20cream%20gradient%20background%2C%20gentle%20cinematic%20lighting%2C%20modern%20minimalist%20poster%20layout%2C%20delicate%20emotional%20tone%2C%20high%20detail%20editorial%20key%20art&width=400&height=600&seq=film-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20young%20woman%20sitting%20by%20a%20rainy%20window%20at%20night%20looking%20at%20her%20phone%20with%20a%20hopeful%20expression%2C%20warm%20amber%20lamplight%20and%20deep%20red%20accents%2C%20soft%20bokeh%20city%20lights%2C%20film%20grain%20texture%2C%20intimate%20and%20tender%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-02&orientation=landscape",
    type: "电视剧",
    region: "国产",
    year: 2024,
    genres: ["爱情", "都市"],
    cast: ["顾念", "沈亦舟", "许知夏"],
    director: "程雨桐",
    synopsis:
      "一次错发的语音消息，让两条原本平行的人生轨迹意外交汇。隔着屏幕的心动，能否在现实中得到回应？",
    plot: [
      "《心动信号》以现代都市通讯为背景，讲述电台主播顾念与数据分析师沈亦舟之间由一条错发语音开启的缘分。顾念误将一段私密倾诉发送给了陌生号码的沈亦舟，两人由此展开了持续数月的匿名交流。",
      "在一次次深夜的语音往来中，他们分享着各自的孤独、梦想与不安，却始终没有见过彼此的脸。当命运安排他们以另一种身份在现实中相遇，误会与心动同时发酵。",
      "剧集细腻刻画了数字时代下年轻人既渴望连接又害怕靠近的复杂情感，用温柔克制的镜头语言，讲述了一个关于勇气与真诚的故事。",
    ],
    heat: 8720,
    releaseDate: "2024-10-02",
    featured: true,
  },
  {
    id: "city-love-song",
    title: "都市恋歌",
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20romance%20series%20poster%20with%20a%20stylish%20couple%20standing%20back%20to%20back%20against%20a%20modern%20city%20skyline%20at%20dusk%2C%20deep%20charcoal%20and%20warm%20red%20tones%2C%20moody%20cinematic%20lighting%2C%20elegant%20minimalist%20poster%20design%2C%20high%20detail%20editorial%20key%20art&width=400&height=600&seq=film-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20two%20figures%20standing%20on%20a%20high%20balcony%20overlooking%20a%20glowing%20city%20skyline%20at%20night%2C%20warm%20amber%20window%20lights%20against%20deep%20charcoal%20sky%2C%20soft%20cinematic%20haze%2C%20film%20grain%2C%20romantic%20and%20melancholic%20mood%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-03&orientation=landscape",
    type: "电视剧",
    region: "国产",
    year: 2023,
    genres: ["爱情", "都市", "职场"],
    cast: ["白清歌", "顾亦辰", "罗雨珊"],
    director: "许延",
    synopsis:
      "三个怀揣梦想的年轻人在这座城市里相爱、争执、成长，用青春谱写一曲笑泪交织的都市恋歌。",
    plot: [
      "《都市恋歌》聚焦三位在大城市打拼的年轻人，通过他们的工作与情感生活，折射出当代都市青年的真实处境。女主角白清歌是一名执着的室内设计师，男主角顾亦辰则是一位理想主义的音乐制作人。",
      "两人因工作结识，从互相欣赏到渐生情愫，却也因为对未来方向的不同选择而屡屡产生分歧。与此同时，好友罗雨珊的加入让三人之间的关系更加微妙。",
      "剧集用细腻的群像叙事，描绘了爱情与理想之间的拉扯，以及在喧嚣都市中坚守本心的可贵。",
    ],
    heat: 7640,
    releaseDate: "2023-06-18",
    featured: true,
  },
  {
    id: "star-promise",
    title: "星光下的约定",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20showing%20a%20couple%20silhouetted%20under%20a%20vast%20starry%20night%20sky%20on%20a%20hilltop%2C%20deep%20red%20and%20gold%20accents%2C%20dreamy%20cinematic%20lighting%2C%20epic%20and%20tender%20mood%2C%20minimalist%20poster%20composition%20with%20negative%20space%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20young%20couple%20lying%20on%20a%20grassy%20hill%20gazing%20at%20a%20brilliant%20milky%20way%20of%20stars%2C%20warm%20golden%20glow%2C%20deep%20crimson%20horizon%2C%20soft%20cinematic%20haze%2C%20film%20grain%20texture%2C%20romantic%20and%20wistful%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-04&orientation=landscape",
    type: "电影",
    region: "国产",
    year: 2025,
    genres: ["爱情", "剧情"],
    cast: ["夏晚星", "江野", "温子昂"],
    director: "梁书宁",
    synopsis:
      "一次天文夏令营的相遇，让他们许下十年后重回山顶看星的约定。十年之约，是否还能兑现？",
    plot: [
      "《星光下的约定》是一部关于时间与承诺的爱情电影。故事始于高中时代的天文夏令营，内向的天文少女夏晚星与张扬的少年江野在观星夜相遇，两人在漫天星光下许下十年后重回山顶的约定。",
      "十年间，城市变迁，人也散落天涯。当约定的日子临近，已成为纪录片导演的江野决定踏上寻找夏晚星的旅程。一路上，他重遇了旧日伙伴，也逐渐拼凑出当年未曾说出口的心意。",
      "影片以浪漫而克制的叙事，探讨了记忆、错过与重逢，献给所有曾经认真许下承诺的人。",
    ],
    heat: 8210,
    releaseDate: "2025-02-14",
    featured: true,
  },
  {
    id: "sweet-trap",
    title: "甜蜜陷阱",
    poster:
      "https://readdy.ai/api/search-image?query=Suspense%20romance%20drama%20poster%20with%20a%20glamorous%20woman%20holding%20a%20rose%20with%20a%20mysterious%20smile%2C%20deep%20burgundy%20and%20black%20palette%2C%20dramatic%20side%20lighting%2C%20elegant%20enigmatic%20poster%20design%2C%20high%20detail%20editorial%20key%20art&width=400&height=600&seq=film-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20an%20elegant%20woman%20standing%20in%20a%20lavish%20dim%20ballroom%20with%20a%20cryptic%20expression%2C%20deep%20burgundy%20and%20gold%20lighting%2C%20moody%20suspense%20atmosphere%2C%20soft%20cinematic%20haze%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-05&orientation=landscape",
    type: "电视剧",
    region: "日韩",
    year: 2023,
    genres: ["爱情", "悬疑"],
    cast: ["尹智雅", "李承贤", "朴敏书"],
    director: "金泰旭",
    synopsis:
      "一场精心设计的甜蜜邂逅，背后藏着不为人知的秘密。当爱情成为一场赌局，谁才是真正的猎物？",
    plot: [
      "《甜蜜陷阱》讲述女继承人尹智雅与神秘商人李承贤之间充满算计的爱情博弈。智雅为调查家族企业内幕而刻意接近承贤，却发现对方似乎同样另有所图。",
      "两人在互相试探中步步为营，甜蜜的表象下暗流涌动。随着真相逐渐浮出水面，原本精心编织的陷阱，却困住了设局者自己的心。",
      "剧集融合悬疑与爱情元素，以紧凑的节奏和反转不断的剧情，呈现出成年世界复杂而危险的情感博弈。",
    ],
    heat: 6980,
    releaseDate: "2023-09-08",
    featured: false,
  },
  {
    id: "time-lovers",
    title: "时光恋人",
    poster:
      "https://readdy.ai/api/search-image?query=Fantasy%20romance%20film%20poster%20showing%20a%20couple%20reaching%20toward%20each%20other%20across%20a%20glowing%20vintage%20clock%2C%20warm%20amber%20and%20deep%20red%20palette%2C%20ethereal%20cinematic%20lighting%2C%20dreamlike%20mood%2C%20elegant%20minimalist%20poster%20design%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20couple%20standing%20in%20an%20old%20library%20surrounded%20by%20floating%20glowing%20clock%20fragments%2C%20warm%20amber%20and%20deep%20crimson%20light%2C%20ethereal%20magical%20atmosphere%2C%20soft%20cinematic%20haze%2C%20film%20grain%2C%20high%20detail%20fantasy%20composition&width=1600&height=900&seq=film-backdrop-06&orientation=landscape",
    type: "电影",
    region: "欧美",
    year: 2022,
    genres: ["爱情", "奇幻"],
    cast: ["Emma Hart", "Noah Reed", "Sophie Lane"],
    director: "Daniel Cole",
    synopsis:
      "一块能逆转时间的怀表，让相隔百年的两个人相遇相爱，却也让他们注定无法同时存在于同一个时空。",
    plot: [
      "《时光恋人》是一部浪漫奇幻电影。古董修复师 Emma 在整理一座旧宅时发现了一块神秘的怀表，每当指针逆转，她便会穿越到一百年前，遇见年轻的钟表匠 Noah。",
      "两人在不同时空中反复相遇、相识、相爱，却始终无法在同一个时间点长久停留。为了留住彼此，他们试图找到打破时间法则的方法。",
      "影片以唯美的视觉与深情的叙事，讲述了一段跨越时间的情感，探讨了爱与失去之间的永恒命题。",
    ],
    heat: 6530,
    releaseDate: "2022-11-20",
    featured: false,
  },
  {
    id: "youth-chronicle",
    title: "青春纪事",
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20coming%20of%20age%20drama%20poster%20showing%20a%20group%20of%20cheerful%20students%20on%20a%20sunlit%20campus%20lawn%2C%20warm%20amber%20and%20soft%20red%20tones%2C%20nostalgic%20cinematic%20lighting%2C%20energetic%20warm%20mood%2C%20minimalist%20poster%20layout%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20group%20of%20teenage%20friends%20cycling%20together%20down%20a%20tree-lined%20road%20in%20late%20afternoon%20sun%2C%20warm%20golden%20light%20and%20soft%20red%20accents%2C%20nostalgic%20film%20grain%2C%20joyful%20and%20bittersweet%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-07&orientation=landscape",
    type: "电视剧",
    region: "国产",
    year: 2022,
    genres: ["青春", "校园", "剧情"],
    cast: ["何以安", "苏念", "林亦然", "程阳"],
    director: "周斯远",
    synopsis:
      "一群普通高中生在三年时光里经历的友情、暗恋与抉择，记录下青春最真实也最闪亮的模样。",
    plot: [
      "《青春纪事》以一所普通高中为舞台，讲述六位性格迥异的少年少女在高中三年中的成长故事。他们一起熬夜复习、参加运动会、组建乐队，也一起面对友情的裂痕与懵懂的心动。",
      "剧集没有刻意的戏剧化冲突，而是以真实细腻的日常细节，还原青春里那些微小却闪光的瞬间。每一次争吵、每一场告别，都成为他们成长的注脚。",
      "作品聚焦于青春本身的力量，献给每一个曾经迷茫却依然勇敢前行的人。",
    ],
    heat: 5410,
    releaseDate: "2022-04-15",
    featured: false,
  },
  {
    id: "mist-pursuit",
    title: "迷雾追凶",
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20series%20poster%20showing%20a%20detective%20silhouette%20against%20a%20foggy%20city%20street%20at%20night%2C%20deep%20charcoal%20and%20blood%20red%20palette%2C%20moody%20dramatic%20lighting%2C%20tense%20cinematic%20atmosphere%2C%20minimalist%20poster%20design%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20lone%20detective%20standing%20in%20dense%20fog%20on%20a%20rain-slicked%20city%20street%20under%20streetlights%2C%20deep%20charcoal%20and%20deep%20red%20tones%2C%20moody%20tense%20atmosphere%2C%20soft%20cinematic%20haze%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-08&orientation=landscape",
    type: "电视剧",
    region: "欧美",
    year: 2024,
    genres: ["悬疑", "犯罪", "剧情"],
    cast: ["James Carter", "Olivia Brooks", "Ethan Wade"],
    director: "Marcus Hale",
    synopsis:
      "一桩尘封二十年的悬案重新被翻出，退休警探不得不重返迷雾之城，追查真相，也面对自己的过去。",
    plot: [
      "《迷雾追凶》是一部氛围阴郁的犯罪悬疑剧。退休警探 James 因一桩旧案的新线索被迫重返警局，而受害者正是他当年未能拯救的故人。",
      "随着调查深入，他发现案件背后牵扯出这座城市隐藏多年的秘密，以及自己职业生涯中最大的遗憾。真相每揭开一层，危险便更近一步。",
      "剧集以冷峻克制的叙事风格与层层递进的悬念，构筑了一部关于正义、赎罪与人性的现代黑色故事。",
    ],
    heat: 7320,
    releaseDate: "2024-03-22",
    featured: false,
  },
  {
    id: "jianghu-sons",
    title: "江湖儿女",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20film%20poster%20showing%20a%20swordsman%20in%20flowing%20red%20robe%20standing%20on%20a%20cliff%20in%20mist%2C%20deep%20crimson%20and%20ink%20black%20palette%2C%20dramatic%20cinematic%20lighting%2C%20epic%20elegant%20poster%20design%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20lone%20swordsman%20in%20red%20robes%20facing%20an%20army%20across%20a%20misty%20battlefield%20at%20dawn%2C%20deep%20crimson%20banners%20and%20ink%20black%20silhouettes%2C%20epic%20cinematic%20lighting%2C%20soft%20haze%2C%20film%20grain%2C%20high%20detail%20majestic%20composition&width=1600&height=900&seq=film-backdrop-09&orientation=landscape",
    type: "电影",
    region: "国产",
    year: 2021,
    genres: ["武侠", "动作", "剧情"],
    cast: ["沈孤鸿", "柳如是", "聂云"],
    director: "关山月",
    synopsis:
      "刀光剑影的乱世江湖中，一位身负血仇的剑客与一位心怀天下的医女相遇，共同揭开一场关乎苍生的阴谋。",
    plot: [
      "《江湖儿女》以架空武侠时代为背景，讲述剑客沈孤鸿为查明师门灭门真相，孤身踏入纷乱的江湖。途中他结识了悬壶济世的医女柳如是，两人一刚一柔，结伴同行。",
      "随着线索铺展，他们逐渐接近一场牵动朝野的巨大阴谋。沈孤鸿在复仇与苍生之间艰难抉择，而柳如是用她的仁心一点点融化他心中的冰霜。",
      "影片以恢弘的武打场面与诗意的东方美学，重塑了传统江湖中的侠义与柔情。",
    ],
    heat: 4890,
    releaseDate: "2021-08-27",
    featured: false,
  },
  {
    id: "fantasy-city",
    title: "幻想之城",
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20film%20poster%20showing%20a%20futuristic%20cityscape%20with%20warm%20orange%20neon%20against%20deep%20charcoal%20sky%2C%20a%20lone%20figure%20looking%20up%2C%20dramatic%20cinematic%20lighting%2C%20grand%20epic%20poster%20composition%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20vast%20futuristic%20metropolis%20at%20dusk%20with%20warm%20amber%20and%20deep%20red%20neon%20lights%20reflecting%20on%20glass%20towers%2C%20a%20small%20figure%20standing%20on%20a%20bridge%2C%20epic%20cinematic%20atmosphere%2C%20soft%20haze%2C%20film%20grain%2C%20high%20detail%20sci-fi%20composition&width=1600&height=900&seq=film-backdrop-10&orientation=landscape",
    type: "电影",
    region: "欧美",
    year: 2023,
    genres: ["科幻", "剧情", "悬疑"],
    cast: ["Ryan Cole", "Mia Foster", "Leo Nash"],
    director: "Sarah Vaughn",
    synopsis:
      "在一座由记忆构建的虚拟城市里，一名建筑师发现自己的记忆正在被悄悄篡改，真相远比想象中危险。",
    plot: [
      "《幻想之城》构建了一个由人类集体记忆驱动的虚拟都市。建筑师 Ryan 在一次系统故障中，发现自己关于过去的记忆出现了无法解释的矛盾。",
      "为了查明真相，他潜入城市的最底层数据区，与黑客 Mia 联手，逐步揭开这座城市背后的秘密——原来整座城市的存在，本身就是一个巨大的谎言。",
      "影片以震撼的视效与哲思性的叙事，探讨了记忆、身份与真实之间模糊的边界。",
    ],
    heat: 6120,
    releaseDate: "2023-05-19",
    featured: false,
  },
  {
    id: "deep-sea-rescue",
    title: "深海救援",
    poster:
      "https://readdy.ai/api/search-image?query=Disaster%20action%20film%20poster%20showing%20a%20diver%20descending%20into%20deep%20dark%20ocean%20with%20a%20single%20warm%20light%20beam%2C%20deep%20red%20and%20charcoal%20palette%2C%20dramatic%20cinematic%20lighting%2C%20tense%20epic%20mood%2C%20minimalist%20poster%20design%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20inside%20a%20deep-sea%20submersible%20cockpit%20with%20a%20crew%20of%20rescuers%20facing%20glowing%20red%20alarm%20lights%2C%20deep%20ocean%20darkness%20outside%2C%20high%20tension%20cinematic%20atmosphere%2C%20soft%20haze%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-11&orientation=landscape",
    type: "电影",
    region: "国产",
    year: 2024,
    genres: ["灾难", "动作", "剧情"],
    cast: ["方震", "黎晓", "高岩"],
    director: "吴海涛",
    synopsis:
      "一场突如其来的海底事故，让一支救援小队身陷绝境。在氧气与时间同时流逝的深渊里，他们必须做出生死抉择。",
    plot: [
      "《深海救援》讲述一支专业深海救援队在执行任务时遭遇罕见海底地质灾害的故事。队长方震带领队员深入数千米的深海，营救被困的科研潜艇。",
      "随着事故升级，救援设备接连失效，队员们必须在极限环境中彼此信任、协同作战。每一次下潜都可能是最后一次。",
      "影片以紧张刺激的场面调度与真实震撼的深海视效，歌颂了平凡英雄在危难面前的勇气与担当。",
    ],
    heat: 7050,
    releaseDate: "2024-07-05",
    featured: false,
  },
  {
    id: "laugh-family",
    title: "笑闹一家人",
    poster:
      "https://readdy.ai/api/search-image?query=Family%20comedy%20series%20poster%20showing%20a%20big%20cheerful%20family%20gathered%20around%20a%20dining%20table%2C%20warm%20orange%20and%20cream%20tones%2C%20cozy%20bright%20cinematic%20lighting%2C%20joyful%20heartwarming%20mood%2C%20playful%20minimalist%20poster%20design%2C%20high%20detail%20key%20art&width=400&height=600&seq=film-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20lively%20family%20laughing%20together%20in%20a%20warm%20cozy%20living%20room%20during%20a%20holiday%20gathering%2C%20warm%20amber%20and%20soft%20orange%20tones%2C%20cheerful%20heartwarming%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20film%20grain%2C%20high%20detail&width=1600&height=900&seq=film-backdrop-12&orientation=landscape",
    type: "电视剧",
    region: "国产",
    year: 2023,
    genres: ["喜剧", "家庭"],
    cast: ["王丽华", "赵大勇", "赵灵儿", "赵小乐"],
    director: "孙怡",
    synopsis:
      "一个热闹的三代同堂家庭，每天都上演着鸡飞狗跳又温暖治愈的生活喜剧，笑声从未停歇。",
    plot: [
      "《笑闹一家人》以赵家三代同堂的日常生活为主线，讲述一家人在柴米油盐中碰撞出的欢笑与温情。爷爷奶奶的传统观念、父母的务实操心、年轻一代的新潮想法，在同一屋檐下不断擦出火花。",
      "每一集围绕一件家庭小事展开，从装修风波到宠物大战，从节日团聚到邻里纠纷，笑料密集又贴近生活。",
      "剧集用轻松幽默的笔触，传递出家人之间无论争吵多少，始终彼此牵挂的温暖内核。",
    ],
    heat: 5810,
    releaseDate: "2023-12-01",
    featured: false,
  },
];

export const getFilmById = (id: string): Film | undefined =>
  films.find((film) => film.id === id);